export const SET_CART = 'SET_CART';
export const SET_CART_QTY = 'SET_CART_QTY';
export const SET_CART_SUCCESS = 'SET_CART_SUCCESS';
export const SET_CART_SUCCESS_SERVER = 'SET_CART_SUCCESS_SERVER';
export const SET_CART_STATE = 'SET_CART_STATE';